import type { Company } from "@entities/company";
import { removeCompanyHeader, setCompanyHeader } from "../http";

export interface Payload {
  isSuperUser: boolean;
  pathname: string;
  companies: unknown[];
  isSessionChecked: boolean;
  isCompaniesLoaded: boolean;
  activeCompany: Company | void | null;
}

export const rememberActiveCompany = (company: Company) =>
  setCompanyHeader(company.id);

export const forgetActiveCompany = () => removeCompanyHeader();

const isLoggedOutRoute = (pathname: string) =>
  ["/login", "/signup", "/verify-email"].includes(pathname);

export const findCompanyByIdOrFirst = (
  companies: Company[],
  id: number,
): Company | null => companies.find((c) => c.id === id) ?? companies[0] ?? null;

export const shouldLetUserIn = ({
  isSuperUser,
  pathname,
  companies,
  isCompaniesLoaded,
  isSessionChecked,
  activeCompany,
}: Payload): boolean => {
  const isLoggedOut = isLoggedOutRoute(pathname);

  /**
   * Users should see loading when the system haven't checked their identity
   */
  if (!isSessionChecked || !isCompaniesLoaded) return false;

  /**
   * Not authenticated users should be able to see login/signup/verify-token pages
   */
  if (isLoggedOut) return true;

  /**
   * Users may have 0 companies:
   * 1. When logged in as a superuser
   * 2. When the user haven't been invited to any company so far
   *
   * We let them in too
   */
  if (!companies.length) return true;

  if (isSuperUser) return true;

  return !!activeCompany;
};
